import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SignUpConfigResponse } from '../../../../Auth/logic/Auth.types';
import { USER_ACTIVE_ROLE_ID_STORAGE_KEY } from './constant';

const initialState: {
  isOpen: boolean;
  isCreateAccountSelectorOpen: boolean;
  title: string;
  activeRoleId: string | null;
} = {
  isOpen: false,
  isCreateAccountSelectorOpen: false,
  activeRoleId: null,
  title: 'Switch to Account',
};

export const accountSwitcherReducer = createSlice({
  name: 'accountSwitcher',
  initialState,
  reducers: {
    setActiveRole(state, action: PayloadAction<{ roleId: string | null }>) {
      const { roleId } = action.payload;
      if (roleId !== null) {
        state.activeRoleId = roleId;
        localStorage.setItem(USER_ACTIVE_ROLE_ID_STORAGE_KEY, roleId);
      }
    },
    // setActiveRole ignores null, so a stale stored role needs its own action.
    clearActiveRole(state) {
      state.activeRoleId = null;
      localStorage.removeItem(USER_ACTIVE_ROLE_ID_STORAGE_KEY);
    },
    setOpen(state, action: PayloadAction<{ isOpen: boolean }>) {
      state.isOpen = action?.payload?.isOpen;
    },
    setCreateAccountSelectorOpen(state, action: PayloadAction<{ isOpen: boolean }>) {
      state.isCreateAccountSelectorOpen = action?.payload?.isOpen;
    },
    setTitle(state, action: PayloadAction<{ title: string }>) {
      state.title = action?.payload?.title;
    },
  },
});
export const { setOpen, setCreateAccountSelectorOpen, setTitle, setActiveRole, clearActiveRole } = accountSwitcherReducer.actions;

export default accountSwitcherReducer.reducer;
